import React from 'react';
import { NiceFormGroup } from './Components.styles';

const TextInput = ({ label, placeholder, onChange, name, value, required }) => {
	return (
		<NiceFormGroup>
			<label>{label}</label>
			<input
				type="text"
				placeholder={placeholder}
				onChange={onChange}
				name={name}
				value={value}
				required={required}
			/>
		</NiceFormGroup>
	);
};

export default TextInput;
